import { LABEL_TYPES } from '@/constants';

export function getStartValue(startAt, min, max, reverseDirrection) {
  return startAt || (reverseDirrection ? max : min);
}

function getNextLettersLabel(lettersAsciiArray, shift = 1) {
  const letterMin = 65;
  const lettersCount = 26;
  const correctionNumberBase26 = (lettersCount - 1).toString(lettersCount);
  const numberArrBase26 = lettersAsciiArray.map((val) => (val - letterMin).toString(lettersCount));
  numberArrBase26.unshift(correctionNumberBase26);
  const numberBase26 = numberArrBase26.join('');
  const newNumberBase10 = parseInt(numberBase26, lettersCount) + shift;
  const newNumberArrBase26 = newNumberBase10.toString(lettersCount).split('');
  const correctionNumberWasTouched = newNumberArrBase26[0] !== correctionNumberBase26;
  newNumberArrBase26.shift();
  if (correctionNumberWasTouched && shift < 0) {
    newNumberArrBase26.shift();
  }

  return newNumberArrBase26.map((val) => parseInt(val, lettersCount) + letterMin);
}

export function getStartValueForLiteral(startAt, count, reverseDirrection) {
  const startLettersAscii = [];
  if (startAt) {
    for (let i = 0; i < startAt.length; i++) {
      startLettersAscii.push(startAt.charCodeAt(i));
    }
    return startLettersAscii;
  }
  if (!reverseDirrection) {
    return [65];
  }
  return getNextLettersLabel([65], count - 1);
}

function numberIsOdd(num) {
  return num % 2;
}

function* labelsMaker(type, startAt = '', prefix, count, reverseDirrection, excludes = []) {
  let currentLabel;
  let nextRatio;
  let firstBackStep;
  switch (type) {
    case LABEL_TYPES.NUMERICAL:
      currentLabel = getStartValue(+startAt, 1, count, false);
      while (true) {
        if (!excludes.includes(currentLabel.toString().toUpperCase())) {
          yield prefix + currentLabel;
        }
        currentLabel += 1;
      }
    case LABEL_TYPES.LITERAL:
      currentLabel = getStartValueForLiteral(startAt.toUpperCase(), count);
      while (true) {
        const lbl = String.fromCharCode(...currentLabel);
        if (!excludes.includes(lbl.toUpperCase())) {
          yield prefix + lbl;
        }
        currentLabel = getNextLettersLabel(currentLabel, 1);
      }
    case LABEL_TYPES.DOUBLELITERAL:
      currentLabel = getStartValueForLiteral(startAt.toUpperCase(), count);
      while (true) {
        const lbl = String.fromCharCode(...currentLabel) + String.fromCharCode(...currentLabel);
        if (!excludes.includes(lbl.toUpperCase())) {
          yield prefix + String.fromCharCode(...currentLabel) + String.fromCharCode(...currentLabel);
        }
        currentLabel = getNextLettersLabel(currentLabel, 1);
      }
    case LABEL_TYPES.ODD:
      nextRatio = 1;
      currentLabel = getStartValue(startAt, 1, (count - 1) * 2 - 1, false);
      if (!numberIsOdd(currentLabel)) {
        currentLabel += nextRatio;
      }
      while (true) {
        if (!excludes.includes(currentLabel.toString().toUpperCase())) {
          yield prefix + currentLabel;
        }
        currentLabel += 2 * nextRatio;
      }
    case LABEL_TYPES.EVEN:
      nextRatio = 1;
      currentLabel = getStartValue(startAt, 2, 2 * count, false);
      if (numberIsOdd(currentLabel)) {
        currentLabel += nextRatio;
      }
      while (true) {
        if (!excludes.includes(currentLabel.toString().toUpperCase())) {
          yield prefix + currentLabel;
        }
        currentLabel += 2 * nextRatio;
      }
    case LABEL_TYPES.ODD_EVEN:
      nextRatio = 2;
      currentLabel = reverseDirrection ? 2 : 1;
      while (true) {
        if (!excludes.includes(currentLabel.toString().toUpperCase())) {
          yield prefix + currentLabel;
        }
        currentLabel += nextRatio;
        if (currentLabel >= count) {
          currentLabel = count;
          nextRatio = (numberIsOdd(count) || reverseDirrection) && !(numberIsOdd(count) && reverseDirrection) ? -1 : -2;
          firstBackStep = true;
        } else if (firstBackStep) {
          nextRatio = -2;
        }
      }
    case LABEL_TYPES.EVEN_ODD:
      nextRatio = -2;
      if (reverseDirrection) {
        currentLabel = numberIsOdd(count) ? count - 1 : count;
      } else {
        currentLabel = numberIsOdd(count) ? count : count - 1;
      }

      while (true) {
        if (!excludes.includes(currentLabel.toString().toUpperCase())) {
          yield prefix + currentLabel;
        }
        currentLabel += nextRatio;
        if (currentLabel < 1) {
          currentLabel = reverseDirrection ? 1 : 2;
          nextRatio = 2;
          firstBackStep = true;
        } else if (firstBackStep) {
          nextRatio = 2;
        }
      }
    default:
      break;
  }
}

export class LabelsGenerator {
  static getLabelsForType(type, startAt, prefix, count, reverseDirrection, excludes) {
    const gen = labelsMaker(type, startAt, prefix, count, reverseDirrection, excludes);
    let arr = [...Array(count)].map(() => gen.next().value);
    if (
      (type === LABEL_TYPES.DOUBLELITERAL ||
        type === LABEL_TYPES.LITERAL ||
        type === LABEL_TYPES.NUMERICAL ||
        type === LABEL_TYPES.EVEN ||
        type === LABEL_TYPES.ODD) &&
      reverseDirrection
    ) {
      arr = arr.reverse();
    }
    return arr;
  }
}
